import React, { useState } from 'react'
import HTTPClient from 'services/HTTPClient';
import { TOPICS } from 'utils'
import { useQuery } from '@tanstack/react-query';
import ErrorIndicator from 'components/ErrorIndicator';
import Messages from 'components/Messages';
import AuthService from 'services/AuthService';
import Spinner from 'components/Spinner';

type Props = {}

const getChatMessages = async (chatRoomID) => {
    if (chatRoomID === undefined) {
        return []
    }
    let messagesResponse = await HTTPClient.get().getJSONResult(`/api/chat-messages?filters[chat_room][id]=${chatRoomID}&populate=author&pagination[start]=0&pagination[limit]=50&sort[0]=createdAt`);
    console.log(messagesResponse)
    return messagesResponse.data.map(message => {
        return {
            id: message.id,
            ...message.attributes,
            author: message.attributes.author.data
        }
    })

};

const useChatRoom = (context) => {
    const url = `/api/chat-room/main?context=${context}`
    const { data: chatRoom, isLoading, error } = useQuery(['chatRoom', context], () => HTTPClient.get().getJSONResult(url));
    const chatRoomID = chatRoom?.id
    let { data: messages, isLoading: isLoadingMessages, error: messagesError } = useQuery(['chatMessages', chatRoomID], () =>
        getChatMessages(chatRoomID)
    );
    console.log(messages)
    return { data: messages, isLoading: isLoadingMessages || isLoading, error: error || messagesError }
};

export default function ConversationsPage({ }: Props) {
    const [topic, setTopic] = useState(TOPICS[0].topic)
    const { data: messages, isLoading, error } = useChatRoom(topic);

    return (
        <div className='mx-0 px-5 py-5' style={{
            display: "grid",
            gridTemplateColumns: "minmax(1px, auto) minmax(1fr, 1000px)",
            height: "100vh"
        }}>
            <h3 className='is-size-3'>
                <strong>Conversations</strong>
            </h3>
            <div className="columns" style={{ maxHeight: "90vh" }}>
                <div
                    className="column is-one-third conversations-topic-list"
                    style={{ minWidth: 200, overflow: "auto" }}>
                    {TOPICS.map(t => {
                        return <div
                            key={t.topic}
                            className={'topic ' + (topic === t.topic ? "selected" : "")}
                            onClick={() => setTopic(t.topic)}>
                            <div
                                className="topic-image"
                                style={{ backgroundColor: t.color }}
                            >
                                {<t.icon fill="grey" width={30} height={30} />}
                            </div>
                            <div className='center'>
                                <h3 className='topic-title is-size-5'>{t.label}</h3>
                            </div>
                        </div>
                    })}
                </div>
                <div className="column mx-4 conversations-list" style={{ overflow: "auto" }}>
                    {isLoading ? <div className="center">
                        <Spinner className='mt-6' />
                    </div> : null}
                    {error ? <ErrorIndicator error={error} /> : null}
                    {messages ? <Messages userID={AuthService.getUserID()} messages={messages} isAITyping={false} /> : null}
                </div>
            </div>
        </div>
    )
}